export default "__VITE_ASSET__kAgDTQRN__"